import { IPageFields } from 'generated/types/contentful'
import { Entry } from 'contentful'
import { Asset, parseAsset } from 'services/ContentfulService/models/asset'
import { getEnv } from 'lib/envWrapper'
import { ContentfulEntity, parseSystemFields } from 'services/ContentfulService/utils'
import { parseResource, Resource } from 'services/ContentfulService/models/resource/resource'

export interface Page extends ContentfulEntity {
	canonical?: string
	children: Page[]
	description?: string
	path: string
	noIndex: boolean
	ogImage?: Asset
	resources: Resource[]
	title: string
	slug: string
}

const env = getEnv()
export const parsePage = (rawPage: Entry<IPageFields>): Page => {
	const fields = rawPage.fields
	const canonicalPage = rawPage.fields.canonicalPage
	const canonicalPath = canonicalPage ? canonicalPage.fields.path : rawPage.fields.path
	return {
		canonical: `${env.root_domain}${canonicalPath.charAt(0) === '/' ? '' : '/'}${canonicalPath}`,
		children: (rawPage.fields.children || []).map(p => parsePage(p)),
		description: rawPage.fields.description,
		noIndex: rawPage.fields?.noIndex || false,
		ogImage: fields.ogImage ? parseAsset(fields.ogImage) : undefined,
		path: fields.path,
		resources: fields.resources?.map(fields => parseResource(fields)) || [],
		slug: fields.slug,
		title: fields.title || fields.slug,
		sys: parseSystemFields(rawPage.sys),
		id: rawPage.sys.id
	}
}
